import { spaceCadet } from '@cogneed/react-utils';
import { styled } from '@mui/material';
import TransparentPopover from '../utils/TransparentPopover';

const StyledPopover = styled(TransparentPopover)({
  '& .MuiPaper-root': {
    padding: '2px 4px',
    '& .MuiButton-root': {
      minWidth: 'unset',
      fontSize: 16,
      padding: 2,
      color: spaceCadet[400],
      '& svg': {
        fontSize: 'inherit',
      },
    },
  },
});

export default StyledPopover;
